(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["share-url-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('share-url-block')) {
    class ShareUrlBlock extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('button[data-url]').forEach((btn) => {
          const textEl = btn.querySelector('.share-url-block__text');
          const defaultLabel = btn.dataset.labelDefault || (textEl ? textEl.textContent : '');
          const doneLabel = btn.dataset.labelDone || '✓ Copied';
          btn.addEventListener('click', async (e) => {
            e.preventDefault();
            const url = btn.dataset.url;
            if (!url) return;
            let ok = false;
            try {
              if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(url);
                ok = true;
              } else {
                const ta = document.createElement('textarea');
                ta.value = url;
                ta.setAttribute('readonly', '');
                ta.style.position = 'fixed';
                ta.style.left = '-9999px';
                document.body.appendChild(ta);
                ta.select();
                ok = document.execCommand('copy');
                document.body.removeChild(ta);
              }
            } catch (_) {
              ok = false;
            }
            if (!ok) {
              window.prompt('複製這段網址 / Copy this URL:', url);
              return;
            }
            if (textEl) textEl.textContent = doneLabel;
            btn.setAttribute('data-copied', 'true');
            clearTimeout(btn._resetTimer);
            btn._resetTimer = setTimeout(() => {
              if (textEl) textEl.textContent = defaultLabel;
              btn.removeAttribute('data-copied');
            }, 1800);
          });
        });
      }
    }
    customElements.define('share-url-block', ShareUrlBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
